import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function CtaBanner() {
  return <section className="relative z-10 px-4 sm:px-6" data-id="element-9">
      <div className="mx-auto flex max-w-6xl translate-y-1/2 flex-col items-center justify-between gap-4 rounded-xl bg-[#0f2d5c] px-6 py-6 shadow-xl sm:flex-row sm:px-10" data-id="element-10">
        <h2 className="text-center text-lg font-semibold text-white sm:text-left sm:text-xl" data-id="element-11">
          East West University, One of the Most Esteemed Universities in
          Bangladesh
        </h2>
        <Button className="shrink-0 gap-2 bg-[#b63a2f] text-white hover:bg-[#9f3127]" data-id="element-12">
          Apply Now
          <ArrowRight className="h-4 w-4" data-id="element-13" />
        </Button>
      </div>
    </section>;
}